import React, { createContext, useContext, useRef } from "react";
import { useNavigate, NavigateFunction } from "react-router-dom";

interface NavigationContextProps {
  navigate: NavigateFunction;
}

const NavigationContext = createContext<NavigationContextProps | undefined>(undefined);

export function NavigationProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  // Usar useRef para garantir referência estável
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  return (
    <NavigationContext.Provider value={{ navigate: navigateRef.current }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const ctx = useContext(NavigationContext);
  if (!ctx) throw new Error("useNavigation must be used within NavigationProvider");
  return ctx;
}
